import React, { SyntheticEvent, useEffect, useContext, useState } from 'react';
import styles from './UsersFilter.module.scss';
import filtersStyles from '../../Filters.module.scss';
import { Action, Checkbox, Search, CloseLight } from 'esa-ui-library';
import { v4 as uuid } from 'uuid';
import { PropertyType, useStore, useUpdateEffect } from '../../../../../common';
import { AuthContext } from '../../../../../logic';
import useFilters from '../../../../../common/hooks/useFilters';

const UsersFilter = (): JSX.Element => {
	const [{ activePartners, users }, dispatch] = useStore();
	const [displayUsers, setDisplayUsers] = useState<PropertyType>([]);
	const [active, setActive] = useState<string[]>([]);
	const { token } = useContext(AuthContext);
	const { onFilter } = useFilters();

	useUpdateEffect(() => {
		dispatch('USERS_INIT', { token });
	}, [activePartners]);

	useEffect(() => {
		setDisplayUsers(users);
	}, [users]);

	const getUpdateUsers = (user: string) => {
		const userIndex = active.indexOf(user);
		const newActive = [...active];

		userIndex > -1 ? newActive.splice(userIndex, 1) : newActive.push(user);

		return newActive;
	};

	const onUserChange = (user: string) => {
		const updateUser = getUpdateUsers(user);

		setActive(updateUser);
		onFilter([{ name: 'user_id', value: updateUser.join() }]);
	};

	const onUserRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		setActive([]);
		onFilter([{ name: 'user_id', value: '' }]);
	};

	const getActiveLabels = () => {
		const activeUsers = users.filter((u: PropertyType) => active.some((a) => a === u.value));
		return activeUsers.map((a: PropertyType) => a.label);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels();

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onUserRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	return (
		<Action
			label='Users'
			labelContent={active.length ? getLabelContent() : 'All'}
			select
			className={`${filtersStyles.Filter} 
			${active.length ? filtersStyles.Active : ''} `}
			onDropdownChange={() => setDisplayUsers(users)}
			dataId='users-filter'
		>
			<section>
				<section className={styles.Search} onClick={(e) => e.stopPropagation()}>
					<Search data={users} searchProperty='label' onSearch={setDisplayUsers} small noMargin />
				</section>
				{displayUsers.map((u: PropertyType) => (
					<Checkbox
						key={uuid()}
						label={u.label}
						checked={active.includes(u.value)}
						className={styles.User}
						onChange={() => onUserChange(u.value)}
						dataId={u.name}
					/>
				))}
				{displayUsers?.length === 0 && <p className={styles.EmptyList}>No results</p>}
			</section>
		</Action>
	);
};

export { UsersFilter };
